
import React from 'react';
import { CalendarViewMode } from '../types';
import { useLanguage } from '@/contexts/LanguageContext';
import { Calendar, CalendarDays, CalendarRange, Activity, CalendarClock } from 'lucide-react';
import { useUser } from '@/contexts/UserContext';

interface ViewModeMenuProps {
  onSelect: (mode: CalendarViewMode) => void;
  currentMode: CalendarViewMode;
}

const ViewModeMenu: React.FC<ViewModeMenuProps> = ({
  onSelect,
  currentMode
}) => {
  const { t } = useLanguage();
  const { isAdmin } = useUser();

  // Define all view modes
  const allViewModes = [
    { value: 'day', label: t('dayView') || 'Day', icon: Calendar },
    { value: 'week', label: t('weekView') || 'Week', icon: CalendarDays },
    { value: 'month', label: t('monthView') || 'Month', icon: CalendarClock },
    { value: 'custom', label: t('customView') || 'Custom', icon: CalendarRange },
    { value: 'total-work', label: t('totalWorkView') || 'Total Work', icon: Activity }
  ];

  // Filter view modes based on user role
  const viewModes = isAdmin 
    ? allViewModes 
    : allViewModes.filter(mode => mode.value === 'total-work');

  return (
    <div className="w-full">
      {viewModes.map((mode) => {
        const Icon = mode.icon;
        return (
          <div
            key={mode.value}
            onClick={() => onSelect(mode.value as CalendarViewMode)}
            className={`flex items-center gap-2 px-3 py-2 cursor-pointer rounded-md transition-colors ${
              currentMode === mode.value ? 'bg-primary/10 text-primary font-medium' : 'hover:bg-muted/50'
            }`}
          >
            <Icon className={`h-4 w-4 ${currentMode === mode.value ? 'text-primary' : ''}`} />
            <span>{mode.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ViewModeMenu;
